<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Logs
      </v-card-title>
      <v-card-text v-if="logs.length" class="red--text">
        <template v-for="(item, index) in logs">
        <p :key="index" v-html="item"/>
        </template>
      </v-card-text>
      <v-card-text v-else class="text-xs-center">
        Not found
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    logs: []
  }),

  created () {
    console.stdlog = console.log.bind(console);
    console.logs = [];
    console.error = function () {
      console.logs.push(Array.from(arguments));
      console.stdlog.apply(console, arguments);
    };
  },

  methods: {
    async open () {
      await this.getLogs();
      this.dialog = true;
    },

    close () {
      this.logs = [];
      this.dialog = false;
    },

    getLogs () {
      let arrLogs = console.logs;
      this.logs = arrLogs.map(log => {
        let message = '';
        message += `${log[0]}`;
        if (log.length && log[1]) message += `<br>${log[1].config.method.toUpperCase()} ${log[1].request.responseURL} ${log[1].request.status} (${log[1].request.statusText})`;
        return message;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/DialogLogs.vue